import dayjs from "dayjs";

import IImportation, { ImportationStatus, SourceType } from "@/interfaces/importation.interface";
import { ImportationsMessages } from "@/messages/importations/importations.messages";

interface Props {
  importation: IImportation;
  messages: ImportationsMessages;
}

interface Return {
  formattedDate: string;
  formattedSourceType: string;
  formattedFileName: string;
  formattedStatus: string;
  success: number;
  error: number;
  bgColor?: "success" | "error" | "warning";
}

function useImportationData({ importation, messages }: Props): Return {
  const formattedDate = importation.rowDate
    ? dayjs(importation.rowDate).format("DD/MM/YYYY HH:mm")
    : "-";

  const formattedSourceType =
    importation.sourceType === SourceType.CONTACT
      ? messages.contactOption
      : importation.sourceType === SourceType.PRODUCT
        ? messages.productOption
        : importation.sourceType;

  const formattedFileName = importation.mediaName || "-";

  let formattedStatus = "-";
  let bgColor: "success" | "error" | "warning" | undefined = undefined;
  switch (importation.status) {
    case ImportationStatus.PENDING:
      formattedStatus = messages.pendingOption;
      bgColor = "warning";
      break;
    case ImportationStatus.PROCESSING:
      formattedStatus = messages.processingOption;
      bgColor = "warning";
      break;
    case ImportationStatus.COMPLETED:
      formattedStatus = messages.completedOption;
      bgColor = "success";
      break;
    case ImportationStatus.ERROR:
      formattedStatus = messages.errorOption;
      bgColor = "error";
      break;
    default:
      formattedStatus = importation.status;
      bgColor = undefined;
      break;
  }

  const success = importation.success;
  const error = importation.fail;

  return {
    formattedDate,
    formattedSourceType,
    formattedFileName,
    formattedStatus,
    success,
    error,
    bgColor,
  };
}

export default useImportationData;
